<div class="container">
    <div id="home-page">
        <div id="heading">
            <h1 class="text outline-primary mt-4 mb-3">Here, <em class="text-primary">We Dont Walk! </em> <em class="text-info">We Dont Run!! </em> <b class="text-warning">We Simply FLY!!!</b></h1>
        </div>
        <div class="d-flex">
            <!-- <div class="w-25 m-0">
                <p class="text" id="ready-word">READY</p>
                <p id="to-word">To</p>
                <p id="take-off">Take Off?</p>  
            </div> -->
            <img class="background-image w-75 mx-auto" src="./../../assets/plane2.png" id="home-pic" alt="An aircraft" />
        </div>
    </div>
</div>